import React from 'react'

const TermsAndCondition = () => {
    return (
        <div className="px-8 py-10 mt-20 font-basefont">
            <h1 className="lg:text-4xl text-3xl text-center font-semibold mb-4 border-b pb-4">
                Terms and Conditions
            </h1>
            <div className="max-w-4xl mx-auto mt-8 space-y-6 text-lg leading-relaxed text-gray-800">
                <p>
                    Please read these Terms and Conditions ("Terms") carefully before using the{" "}
                    <a href="https://www.pgoverseasservices.com" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">
                        https://www.pgoverseasservices.com
                    </a>{" "}
                    website (the "Service") operated by PG Overseas Services ("us," "we," or "our").
                </p>

                <p>
                    Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms.
                    These Terms apply to all visitors, users, and others who access or use the Service.
                </p>

                <p className="italic">
                    By accessing or using the Service, you agree to be bound by these Terms. If you disagree with any part of the terms, then you may not access the Service.
                </p>

                <h2 className="text-2xl font-semibold">1. Services Provided</h2>
                <ul className="list-disc list-inside space-y-1">
                    <li>Visa application assistance (study, work, tourist, immigration, etc.).</li>
                    <li>Immigration consultancy and documentation support.</li>
                    <li>Study abroad counseling and university application assistance.</li>
                    <li>Overseas job placement guidance and resume building.</li>
                    <li>[Add additional services like IELTS/TOEFL coaching, travel insurance, etc.]</li>
                </ul>
                <p>The specific scope of services will be outlined in a separate written agreement or proposal.</p>

                <h2 className="text-2xl font-semibold">2. Client Obligations</h2>
                <ul className="list-disc list-inside space-y-1">
                    <li>Provide accurate and complete documents and information.</li>
                    <li>Fully cooperate with our team and provide timely responses.</li>
                    <li>Disclose relevant adverse information (e.g., visa refusals, criminal history).</li>
                    <li>Acknowledge that we act as facilitators and not decision-makers.</li>
                    <li>Ensure timely payment as per the agreed-upon structure.</li>
                </ul>

                <h2 className="text-2xl font-semibold">3. Fees and Payment</h2>
                <ul className="list-disc list-inside space-y-1">
                    <li>Fees will be clearly stated in a written agreement or invoice.</li>
                    <li>All fees are non-refundable unless explicitly agreed otherwise.</li>
                    <li>Payment terms (installments, charges) will be outlined in the agreement.</li>
                    <li>[Add terms on taxes, late fees, etc. if applicable.]</li>
                </ul>

                <h2 className="text-2xl font-semibold">4. Refund Policy</h2>
                <ul className="list-disc list-inside space-y-1">
                    <li>Fees are non-refundable once service has started.</li>
                    <li>Refunds follow the terms in your specific service agreement.</li>
                    <li>No refunds for significant work completed, regardless of outcome.</li>
                    <li>Approved refunds may incur administrative deductions.</li>
                </ul>

                <h2 className="text-2xl font-semibold">5. No Guarantee of Outcome</h2>
                <p>
                    We provide professional guidance but do not guarantee the success of any application or placement. Outcomes depend on third-party decisions (embassies, universities, employers).
                </p>

                <h2 className="text-2xl font-semibold">6. Intellectual Property</h2>
                <p>
                    All content on the Service is the exclusive property of PG Overseas Services and protected under copyright and trademark laws. No part may be reused without permission.
                </p>

                <h2 className="text-2xl font-semibold">7. Links to Other Websites</h2>
                <p>
                    Our Service may contain links to third-party sites not controlled by us. We are not responsible for their content or policies. You should review their terms independently.
                </p>

                <h2 className="text-2xl font-semibold">8. Termination of Service</h2>
                <p>
                    We may suspend or terminate access immediately if you breach Terms or act fraudulently. Paid fees for rendered services are non-refundable.
                </p>

                <h2 className="text-2xl font-semibold">9. Disclaimer of Warranties</h2>
                <p>
                    The Service is provided “as is.” We do not guarantee uninterrupted, secure, or error-free performance, or that it meets your expectations.
                </p>

                <h2 className="text-2xl font-semibold">10. Limitation of Liability</h2>
                <p>
                    PG Overseas Services is not liable for indirect or consequential damages arising from use of the Service, even if we’ve been advised of such risks.
                </p>

                <h2 className="text-2xl font-semibold">11. Governing Law and Jurisdiction</h2>
                <p>
                    These Terms are governed by Indian law, particularly applicable laws in Gujarat. Disputes shall be resolved via arbitration in Ahmedabad under the Arbitration and Conciliation Act, 1996. The arbitration language will be English.
                </p>

                <h2 className="text-2xl font-semibold">12. Changes to These Terms and Conditions</h2>
                <p>
                    We may update these Terms at any time. If changes are material, we will notify users 30 days in advance. Continued use of the Service implies acceptance of changes.
                </p>

                <h2 className="text-2xl font-semibold">13. Contact Us</h2>
                <p>
                    If you have any questions about these Terms, contact us via:
                </p>
                <ul className="list-disc list-inside space-y-1">
                    <li>
                        Website:{" "}
                        <a href="https://www.pgoverseasservices.com/contact" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">
                            https://www.pgoverseasservices.com/contact
                        </a>
                    </li>
                    <li>Phone: +91 9925000431</li>
                </ul>
            </div>
        </div>

    )
}

export default TermsAndCondition